// The app-wide top-bar tabs: the ones that belong to no round.
//
// `roundPrimaryNav.ts` is the same idea for a round's nav, and the two are
// deliberately separate lists rather than one gated list. A round tab points
// inside the round you're in and disappears when you leave it; a global tab
// points at the same place from everywhere. The SiteHeader appends these after
// the round's entries, so the round's own nav still reads on its own.
//
// These carry no phase visibility and no unseen dot — both of those are
// round-relative, and forms and teams aren't.
//
// Width note: the AppBar packs the nav row right-to-left, and inside a round
// at 1440px the round's own tabs already fill it. Added global tabs can push
// the row's last entries into More. Teams is available to the flag's audience;
// Application Builder remains restricted to SFC admins.

export type GlobalNavLinkDef = {
  key: string;
  label: string;
  href: string;
};

const GLOBAL_LINKS: (GlobalNavLinkDef & { requiresSfcAdmin: boolean })[] = [
  {
    key: "application-builder",
    label: "Application Builder",
    href: "/application-builder",
    requiresSfcAdmin: true,
  },
];

export function buildGlobalNavEntries(ctx: {
  isSfcAdmin: boolean;
  teamsEnabled?: boolean;
}): GlobalNavLinkDef[] {
  const entries = GLOBAL_LINKS.filter(
    ({ requiresSfcAdmin }) => ctx.isSfcAdmin || !requiresSfcAdmin,
  ).map(({ key, label, href }) => ({ key, label, href }));
  if (ctx.teamsEnabled)
    entries.push({ key: "teams", label: "My Teams", href: "/teams" });
  return entries;
}
